import { DeliverablesRollup } from '@/components/rollups/Rollups';
import { api } from '@/lib/api';
import { useCompanyCtx } from './CompanyLayout';

/** Every deliverable across this company's engagements, newest first. */
export function CompanyDeliverablesTab() {
  const { company } = useCompanyCtx();
  return (
    <DeliverablesRollup
      fetchKey={`co-${company.id}`}
      fetch={() => api.listCompanyDeliverables(company.id)}
      companySlug={company.slug}
    />
  );
}
